/**
 * Yemek Ücreti Hesaplama Engine
 * 2026 — Günlük istisna: 300 TL (nakit), 330 TL (KDV dahil kart/ayni)
 */

export const YILI = 2026;
export const GUNLUK_ISTISNA_NAKIT = 300;
export const GUNLUK_ISTISNA_KART_KDV_DAHIL = 330;
export const GUNLUK_ISTISNA_KART_KDV_HARIC = 300;
export const KDV_ORAN = 0.1; // %10 yemek KDV

export type OdemeTipi = "nakit" | "kart";

export interface YemekUcretiGirdi {
  odemeTipi: OdemeTipi;
  gunlukTutar: number;
  aylikCalisilanGun: number;
}

export interface YemekUcretiSonuc {
  odemeTipi: OdemeTipi;
  gunlukTutar: number;
  gunlukIstisna: number;
  gunlukVergiyeTabi: number;
  aylikCalisilanGun: number;
  aylikToplamYemek: number;
  aylikIstisnaTutar: number;
  aylikVergiyeTabiTutar: number;
  aylikSgkKesinti: number;
  aylikGelirVergisi: number;
  aylikDamgaVergisi: number;
  aylikToplamKesinti: number;
  aylikNetYemekUcreti: number;
  yillikToplamYemek: number;
  yillikIstisnaTutar: number;
  yillikVergiyeTabiTutar: number;
  tamIstisnaMi: boolean;
}

export function formatTL(value: number): string {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function hesaplaYemekUcreti(girdi: YemekUcretiGirdi): YemekUcretiSonuc {
  const gunlukTutar = Math.max(0, girdi.gunlukTutar || 0);
  const calisilanGun = Math.max(0, girdi.aylikCalisilanGun || 22);
  const odemeTipi = girdi.odemeTipi || "kart";

  // İstisna limiti
  const gunlukIstisna =
    odemeTipi === "kart" ? GUNLUK_ISTISNA_KART_KDV_DAHIL : GUNLUK_ISTISNA_NAKIT;

  // Vergiye tabi günlük tutar
  const gunlukVergiyeTabi = Math.max(0, gunlukTutar - gunlukIstisna);

  // Aylık toplamlar
  const aylikToplamYemek = gunlukTutar * calisilanGun;
  const aylikIstisnaTutar = Math.min(gunlukIstisna, gunlukTutar) * calisilanGun;
  const aylikVergiyeTabiTutar = gunlukVergiyeTabi * calisilanGun;

  // Kesintiler (sadece vergiye tabi kısım üzerinden)
  // Yemek kartlarında SGK primi yok (2026 itibariyle)
  const aylikSgkKesinti =
    odemeTipi === "nakit" ? aylikVergiyeTabiTutar * 0.14 : 0;
  const sgkSonrasiMatrah = aylikVergiyeTabiTutar - aylikSgkKesinti;
  const aylikGelirVergisi = sgkSonrasiMatrah * 0.15;
  const aylikDamgaVergisi = aylikVergiyeTabiTutar * 0.00759;
  const aylikToplamKesinti =
    aylikSgkKesinti + aylikGelirVergisi + aylikDamgaVergisi;
  const aylikNetYemekUcreti = aylikToplamYemek - aylikToplamKesinti;

  // Yıllık
  const yillikToplamYemek = aylikToplamYemek * 12;
  const yillikIstisnaTutar = aylikIstisnaTutar * 12;
  const yillikVergiyeTabiTutar = aylikVergiyeTabiTutar * 12;

  const tamIstisnaMi = gunlukVergiyeTabi <= 0;

  return {
    odemeTipi,
    gunlukTutar,
    gunlukIstisna,
    gunlukVergiyeTabi,
    aylikCalisilanGun: calisilanGun,
    aylikToplamYemek,
    aylikIstisnaTutar,
    aylikVergiyeTabiTutar,
    aylikSgkKesinti,
    aylikGelirVergisi,
    aylikDamgaVergisi,
    aylikToplamKesinti,
    aylikNetYemekUcreti,
    yillikToplamYemek,
    yillikIstisnaTutar,
    yillikVergiyeTabiTutar,
    tamIstisnaMi,
  };
}
